import { AxiosInstance } from 'axios'

import { BaseAPI } from '../../classes/BaseAPI'

export class WaitingRoomAPI extends BaseAPI {
  constructor(axios: AxiosInstance) {
    super(axios)
  }
}
